import { capitalizeOnlyFirstLetter } from "./capitalizeOnlyFirstLetter";

export const getVersionText = (
  version: string | number | undefined | null,
  version_status: string | null | undefined,
  version_name: string | undefined | null,
) => {
  let versionText = version_name || `v.${version}`;

  if (version_status !== "archived") {
    versionText = `${versionText} - ${capitalizeOnlyFirstLetter(
      version_status,
    )}`;
  } else {
    versionText = `${versionText} - Past`;
  }

  return versionText;
};
